import { ERP_OUTSTANDING_REPORT_PDF_URL } from "../components/Shared/constant";

const handleDownloadErpGeneralReport = async (data, token) => {
    const voucherType = encodeURIComponent(data?.voucher_type);
    const voucherNo = encodeURIComponent(data?.invoice_num);
    const downloadUrl = `${ERP_OUTSTANDING_REPORT_PDF_URL}?voucher_type=${voucherType}&voucher_no=${voucherNo}`;

    try {
        const response = await fetch(downloadUrl, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': '*/*',
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to download file: ${response.status}`);
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const filename = `${data?.voucher_type}_${data?.invoice_num}.pdf`;
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Download failed:\n", error);
    }
};

export default handleDownloadErpGeneralReport;